<script setup>
import { computed, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { Overlay, Button, Toast, Icon } from 'vant'
import { getCertificate } from '@/api/certificate'

const route = useRoute()
const router = useRouter()
const store = useStore()

const props = defineProps({
  show: Boolean
})
const emit = defineEmits(['close'])

const showCertificate = ref(true)

watch(() => props.show, (val) => {
  showCertificate.value = val
})

const name = ref(store.getters.getUserSelection?.name || store.getters.getUser?.nickname || '')

async function handleSubmitClick() {
  if (!name.value) {
    Toast({
      message: '请输入您的姓名',
      position: 'bottom',
    })

    return
  }

  try {
    const res = await getCertificate({
      name: name.value,
      questionActiveKey: route.query.questionActiveKey,
    }, {
      headers: {
        'CQ-MEMBER-TOKEN': store.getters.getToken,
      },
    
    })

    if (res.ok) {
      Toast({
        message: '领取成功',
        position: 'center',
      })
      showCertificate.value = false
      setTimeout(() => {
        router.push({
          path: '/person/certificate',
          query: {
            ...route.query,
            name: name.value,
          },
        })
      }, 500);
    } else {
      Toast({
        message: '领取失败',
        position: 'center',
      })
    }

  } catch (error) {
    
  }


}

const handleCloseClick = () => {
  emit('close')
}

const dialogTitle = computed(() => {
  let title =  store.getters.getCertificateTitle

  return title.split('\n').map((item) => {
    return `<p class="tips">${item}</p>`
  }).join('')
})

const subtmitBtnText = computed(() => {
  return store.getters.getCertificateSubmitBtnText
})

const titleStyle = computed(() => {
  return {
    textAlign: store.getters.getCertificateTitleAlign || 'left',
  }
})
</script>
<template>
  <Overlay :show="showCertificate">
    <div class="wrap ">
      <div :style="titleStyle" v-html="dialogTitle"></div>

      <input v-model="name" class="name-input" type="text" placeholder="请输入您的姓名" />
      <Button @click="handleSubmitClick" class="submit-btn">{{ subtmitBtnText }}</Button>

      <!-- 关闭按钮 -->
      <Icon class="close-btn" @click="handleCloseClick" color="#C2C2C2" size="24px" name="cross" />
    </div>
  </Overlay>
</template>
<style scoped lang="scss">
.wrap {
  box-sizing: border-box;
  position: relative;
  margin: 0 auto;
  margin-top: 450px;
  padding-top: 50px;
  padding-bottom: 20px;
  width: 680px;
  min-height: 480px;
  background: #FFFFFF;
  border-radius: 10px;
  z-index: 2077;

  :deep {
    .tips {
      margin: 0 auto;
      margin-top: 14px;
      width: 80%;
      font-size: 36px;
      color: #333333;
      font-weight: bold;
      line-height: 1.4;
    }
  }

  .name-input {
    display: block;
    margin: 0 auto;
    margin-top: 40px;
    padding-left: 25px;
    width: 558px;
    height: 92px;
    border-radius: 5px;
    border: 2px solid #ECECEC;
    color: #333333;
    font-size: 30px;
  }

  .submit-btn {
    display: block;
    margin: 0 auto;
    margin-top: 49px;
    width: 320px;
    height: 88px;
    font-size: 30px;
    color: #FFFFFF;
    background: linear-gradient(90deg, #2FAEFF 0%, #3890FF 100%);
    border-radius: 44px;
  }
  
  .close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}
</style>